// SPAM PROTECTION

const events = ['touchstart', 'keydown', 'mousemove', 'touchmove'];

function addEvents() {
    events.forEach(event => {
        document.addEventListener(event, insertSpamProtectionValue, true);
    });
}

function removeEvents() {
    events.forEach(event => {
        document.removeEventListener(event, insertSpamProtectionValue, true);
    });
}

function insertSpamProtectionValue() {
    const fields = document.querySelectorAll('.js-spam-protection-field');
    [...fields].forEach(field => {
        const form = field.closest('form');

        if (!form) {
            return;
        }

        const stateField = form.querySelector('input[name*=__state]');

        if (stateField) {
            field.value = stateField.value;
        }
    });

    removeEvents();
}

if (document.querySelector('.js-spam-protection-field')) {
    addEvents();
}
